export enum ObjectDetailsMainMenuItemType {
  AUDIO,
  AUDIO_PLAYING,
  STORY,
  VIDEO,
  LOCATION,
  LINK,
  DIRECTION
}
